import $ from "jquery";
import admin from "../admin";
import { startpoll, confirmDialog } from "../auth";
import { I18n } from "react-redux-i18n";
import { tmplparams } from "../order-list-util";
import { createTree } from "jquery.fancytree";
import EntityPageCode from "../../components/EntityPageCode";
import "../cashRegisters";

class CashRegistersCode extends EntityPageCode {

	constructor() {
		super();
		super.publishFunctions(['saveCashRegister', 'deleteCashRegister', 'activateCashRegister', 'installCashRegisterServer']);
	}

	clearData = () => {

	}

	ready = () => {

		$('#main').replaceWith($('#cashRegistersMainTemplate').tmpl({
			...tmplparams()
		}));

		this.loadCashRegisters();

		startpoll(this.serverSideMessageHandler);

		this.updateHooks();
		this.setupPaymentMethodReorder();

		$("button#connect").on("click", () => {
			this.connect();
		});


	}

	reload = () => {
		this.loadCashRegisters();
	}

	loadCashRegisters = () => {
		admin.getCashRegisters(this.processCashRegisters);
	}

	serverSideMessageHandler(data) {
	}

	getPaymentMethodId = paymentMethod => {
		if (paymentMethod !== null && typeof paymentMethod === 'object')
			return paymentMethod?.method?.id ?? paymentMethod?.id;
		return paymentMethod;
	}

	getPaymentMethodKey = paymentMethodId => {
		if (typeof paymentMethodId === 'undefined' || paymentMethodId === null)
			return '';
		return String(paymentMethodId);
	}

	getPaymentMethodIdCandidates = paymentMethod => {
		const idCandidates = [];
		const addCandidate = id => {
			const key = this.getPaymentMethodKey(id);
			if (!key)
				return;
			if (idCandidates.includes(key))
				return;
			idCandidates.push(key);
		};

		if (paymentMethod !== null && typeof paymentMethod === 'object') {
			addCandidate(paymentMethod?.method?.id);
			addCandidate(paymentMethod?.id);
			addCandidate(paymentMethod?.methodId);
			addCandidate(paymentMethod?.paymentMethodId);
			addCandidate(paymentMethod?.payment_method_id);
			addCandidate(paymentMethod?.paymentMethod?.id);
		} else {
			addCandidate(paymentMethod);
		}

		return idCandidates;
	}

	getLabelPaymentMethodKeys = label => {
		const labelRef = $(label);
		const input = labelRef.find('input').first();
		const keys = [
			this.getPaymentMethodKey(input.prop('id')),
			this.getPaymentMethodKey(labelRef.attr('data-payment-method-id')),
			this.getPaymentMethodKey(labelRef.attr('data-payment-method-legacy-id'))
		].filter(k => k);
		return Array.from(new Set(keys));
	}

	getSelectedOrderForKeys = (selectedOrderById, keys) => {
		for (const key of keys) {
			if (typeof selectedOrderById[key] !== 'undefined')
				return selectedOrderById[key];
		}
		return undefined;
	}

	getPaymentMethodType = paymentMethod => {
		if (paymentMethod !== null && typeof paymentMethod === 'object')
			return paymentMethod?.method?.type ?? paymentMethod?.type ?? '';
		return '';
	}

	getPaymentMethodName = paymentMethod => {
		if (paymentMethod !== null && typeof paymentMethod === 'object')
			return paymentMethod?.method?.name ?? paymentMethod?.name ?? '';
		return '';
	}

	normalizeText = value => String(value ?? '').trim().toLowerCase();

	getPaymentMethodOrder = (paymentMethod, fallback = Number.MAX_SAFE_INTEGER) => {
		const orderIndex = Number(paymentMethod?.order_index);
		return !Number.isNaN(orderIndex) ? orderIndex : fallback;
	}

	sortCashRegisterPaymentMethods = paymentMethods => {
		if (!Array.isArray(paymentMethods))
			return [];
		return paymentMethods.slice().sort((a, b) => this.getPaymentMethodOrder(a) - this.getPaymentMethodOrder(b));
	}

	buildPaymentMethodsPayload = paymentMethods => {
		return this.sortCashRegisterPaymentMethods(paymentMethods)
			.map((paymentMethod, index) => ({
				id: this.getPaymentMethodId(paymentMethod),
				order_index: index
			}))
			.filter(paymentMethod => typeof paymentMethod.id !== 'undefined' && paymentMethod.id !== null && paymentMethod.id !== '');
	}

	buildPaymentMethodsPayloadFromEditor = modal => {
		const paymentMethods = [];
		let orderIndex = 0;
		modal.find('#payment_methods label').each((ind, label) => {
			const input = $(label).find('input');
			if (input.prop('checked')) {
				paymentMethods.push({
					id: input.prop('id'),
					order_index: orderIndex++
				});
			}
		});
		return paymentMethods;
	}

	findPaymentMethodInput = (modal, paymentMethod) => {
		const candidateIds = this.getPaymentMethodIdCandidates(paymentMethod);
		let matchedLabel = $();
		if (candidateIds.length > 0) {
			matchedLabel = modal.find('#payment_methods label').filter((ind, label) => {
				const labelKeys = this.getLabelPaymentMethodKeys(label);
				return labelKeys.some(key => candidateIds.includes(key));
			}).first();
		}

		if (!matchedLabel.length) {
			const paymentMethodType = this.normalizeText(this.getPaymentMethodType(paymentMethod));
			if (paymentMethodType) {
				matchedLabel = modal.find('#payment_methods label').filter((ind, label) => {
					return this.normalizeText($(label).attr('data-payment-method-type')) === paymentMethodType;
				}).first();
			}
		}

		if (!matchedLabel.length) {
			const paymentMethodName = this.normalizeText(this.getPaymentMethodName(paymentMethod));
			if (paymentMethodName) {
				matchedLabel = modal.find('#payment_methods label').filter((ind, label) => {
					return this.normalizeText($(label).attr('data-payment-method-name')) === paymentMethodName;
				}).first();
			}
		}

		if (!matchedLabel.length)
			return $();
		return matchedLabel.find('input').first();
	}

	sortPaymentMethodEditorList = (modal, selectedOrderById = {}) => {
		const labels = modal.find('#payment_methods label').get();
		labels.sort((a, b) => {
			const selectedOrderA = this.getSelectedOrderForKeys(selectedOrderById, this.getLabelPaymentMethodKeys(a));
			const selectedOrderB = this.getSelectedOrderForKeys(selectedOrderById, this.getLabelPaymentMethodKeys(b));
			const selectedA = typeof selectedOrderA !== 'undefined';
			const selectedB = typeof selectedOrderB !== 'undefined';
			if (selectedA && selectedB)
				return selectedOrderA - selectedOrderB;
			if (selectedA !== selectedB)
				return selectedA ? -1 : 1;
			const orderA = Number($(a).attr('data-order-index'));
			const orderB = Number($(b).attr('data-order-index'));
			const fallbackOrderA = Number.isNaN(orderA) ? Number.MAX_SAFE_INTEGER : orderA;
			const fallbackOrderB = Number.isNaN(orderB) ? Number.MAX_SAFE_INTEGER : orderB;
			return fallbackOrderA - fallbackOrderB;
		});
		labels.forEach(label => modal.find('#payment_methods').append(label));
	}

	setupPaymentMethodReorder = () => {
		const modal = $('div#editCashRegister');
		modal.off('click.paymentMethodsReorder', '.payment-method-up');
		modal.off('click.paymentMethodsReorder', '.payment-method-down');
		modal.on('click.paymentMethodsReorder', '.payment-method-up', function (event) {
			event.preventDefault();
			event.stopPropagation();
			const label = $(this).closest('label');
			const previous = label.prev('label');
			if (previous.length)
				previous.before(label);
		});
		modal.on('click.paymentMethodsReorder', '.payment-method-down', function (event) {
			event.preventDefault();
			event.stopPropagation();
			const label = $(this).closest('label');
			const next = label.next('label');
			if (next.length)
				next.after(label);
		});
	}


	CashRegisters = null;
	processCashRegisters = (data) => {
		const instance = this;
		data.forEach(function (v, i) {
			v.title = v.name;
			v.type2 = v.type;
			v.folder = false;
			if (!v.isActive)
				v.extraClasses = "itemDeactivated";
			if (v.shareable)
				v.extraClasses += " itemShareable";
		});
		if (this.CashRegisters == null)
			this.CashRegisters = createTree("table#CashRegisters", {
				checkbox: false,
				titlesTabbable: true, // Add all node titles to TAB chain
				source: data,
				zindex: 1000,
				icon: false,
				extensions: ["table", "gridnav", "persist"],
				table: {
					checkboxColumnIdx: 0, // render the checkboxes into the this
					// column index (default: nodeColumnIdx)
					indentation: 16, // indent every node level by 16px
					nodeColumnIdx: 2
					// render node expander, icon, and title to this column (default:
					// #0)
				},
				gridnav: {
					autofocusInput: false, // Focus first embedded input if node
					// gets activated
					handleCursorKeys: true
					// Allow UP/DOWN in inputs to move to prev/next node
				},

				activate: function (event, data) {
					// A node was activated: display its title:
					var node = data.node;
					$('#edit').removeAttr('disabled');
					$('#delete').removeAttr('disabled');
					if (node.data.isActive) {
						$('#deactivate').removeAttr('disabled');
						$('#activate').prop('disabled', 'true');
					} else {
						$('#deactivate').prop('disabled', 'true');
						$('#activate').removeAttr('disabled');
					}

				},
				renderColumns: function (event, data) {
					var node = data.node, $tdList = $(node.tr).find(">td");
					const paymentMethods = instance.sortCashRegisterPaymentMethods(node.data.paymentMethods);

					node.expanded = true;

					$tdList.eq(1).text(node.data.name);
					$tdList.eq(2).text(node.data.connectedDevice);
					$tdList.eq(3).text(node.data.format);
					$tdList.eq(4).text(node.data.type2);
					$tdList.eq(5).text(paymentMethods.map(p => p.name ?? p.method?.name).filter(p => p).join(', '));
				}
			});
		else {
			this.CashRegisters.reload(data);
			$('#edit').prop('disabled', 'true');
			$('#activate').prop('disabled', 'true');
			$('#deactivate').prop('disabled', 'true');
			$('#delete').prop('disabled', 'true');
		}
	}

	updateHooks = () => {
		const instance = this;
		$('div#editCashRegister').on('show.bs.modal', function (event) {
			var modal = $(this)
			var button = $(event.relatedTarget) // Button that triggered the modal
			var recipient = button.data('whatever') // Extract info from data-*
			modal.find('#payment_methods label').removeClass('active');
			modal.find('#payment_methods input').prop('checked', false);
			instance.sortPaymentMethodEditorList(modal);
			// attributes
			if (recipient === 'edit') {
				var data = instance.CashRegisters.getActiveNode().data;
				const paymentMethods = instance.sortCashRegisterPaymentMethods(data.paymentMethods);
				const selectedOrderById = {};
				paymentMethods.forEach((pm, index) => {
					const selectedOrder = instance.getPaymentMethodOrder(pm, index);
					instance.getPaymentMethodIdCandidates(pm).forEach(key => {
						if (typeof selectedOrderById[key] === 'undefined')
							selectedOrderById[key] = selectedOrder;
					});
				});
				modal.find('#id').val(data.id);
				modal.find('#name').val(data.name);
				modal.find('#format').val(data.format);
				modal.find('#type').val(data.type2);
				modal.find('#detailed').prop("checked", data.detailed);
				modal.find('#serviceVat').prop("checked", data.serviceVat);
				if (data.isActive === true)
					modal.find('#active').prop("checked", true);
				else
					modal.find('#active').prop("checked", false);
				modal.find('#ntak').prop("checked", !!data.ntak);
				paymentMethods.forEach(pm => {
					const paymentMethodInput = instance.findPaymentMethodInput(modal, pm);
					if (!paymentMethodInput.length)
						return;
					paymentMethodInput.closest('label').addClass('active');
					paymentMethodInput.prop('checked', true);
				});
				instance.sortPaymentMethodEditorList(modal, selectedOrderById);
			} else {
				modal.find('#id').val("");
				modal.find('#name').val("");
				modal.find('#active').prop("checked", true);
				modal.find('#ntak').prop("checked", false);
				modal.find('#format').val("qrcode");
				modal.find('#type').val("fiscat");
				modal.find('#detailed').prop("checked", true);
				modal.find('#serviceVat').prop("checked", false);
				instance.sortPaymentMethodEditorList(modal);
			}
		})
	}

	saveCashRegister = (connect) => {
		var modal = $('div#editCashRegister');
		var id = modal.find('#id').val();
		var name = modal.find('#name').val();
		var format = modal.find('#format').val();
		var type = modal.find('#type').val();
		var active = modal.find('#active').prop('checked');
		var ntak = modal.find('#ntak').prop('checked');
		var detailed = modal.find('#detailed').prop('checked');
		var serviceVat = modal.find('#serviceVat').prop('checked');
		const paymentMethods = this.buildPaymentMethodsPayloadFromEditor(modal);
		if (id !== '') {
			admin.modifyCashRegister({
				id: id,
				name: name,
				isActive: active,
				format: format,
				type: type,
				paymentMethods: paymentMethods,
				detailed: detailed,
				serviceVat: serviceVat,
				ntak: ntak
			}, 
				this.loadCashRegisters);
		} else {
			admin.addCashRegister({
				name: name,
				isActive: active,
				format: format,
				type: type,
				paymentMethods: paymentMethods,
				detailed: detailed,
				serviceVat: serviceVat
			}, this.loadCashRegisters);
		}
	}

	activateCashRegister = (active) => {
		var data = this.CashRegisters.getActiveNode().data;
		console.log(data);
		admin.modifyCashRegister({
			id: data.id,
			name: data.name,
			isActive: active,
			format: data.format,
			type: data.type2,
			paymentMethods: this.buildPaymentMethodsPayload(data.paymentMethods)
		}, this.loadCashRegisters);
	}

	deleteCashRegister = () => {
		var data = this.CashRegisters.getActiveNode().data;
		const instance = this;
		confirmDialog(I18n.t('local.confirmation'), String.format(I18n.t('admin_local.are_you_sure_you_want_to_delete_the_cashregister'), data.name)).done(function () {
			admin.deleteCashRegister(data.id, instance.loadCashRegisters);
		});

	}

}

export default CashRegistersCode;